// extracted by mini-css-extract-plugin
export default {"wrapper":"delete-product-module_wrapper-nODma","deleteButton":"delete-product-module_deleteButton-qiYFv"};